import languageFile from '../public/languages/Translation'; // component related identifiers are defined here

export var ICON_EDIT = 'edit';
export var ICON_DOWN = 'down';
export var ICON_PLUS = 'plus';
export var ICON_ADD = 'add';
export var ICON_DOWNLOAD = 'download';
export var ICON_VISIBILITY = 'visibility';
export var ICON_VISIBILITY_OFF = 'visibility_off';
export var ICON_ARROW_RIGHT = 'arrow-right';
export var INPUT_TYPE_NUMBER = 'number';
export var INPUT_TYPE_CHECKBOX = 'checkbox';
export var PRIMARY_BUTTON_TYPE = 'primary';
export var SMALL = 'small';
export var PAGE_SIZE_OPTIONS = ['20', '50', '100'];
export var PAGE_SIZE_OPTIONS_LOCATION_CONTROL = ['50', '100', '500'];
export var DATE_FORMAT_LL = 'll';
export var DATE_FORMAT_DD_MMM = 'DD MMM';
export var DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD';
export var SHOW_CLASSNAME = 'show';
export var HIDE_CLASSNAME = 'hide'; //commonly used strings are defined here

export var COULDNOT_CREATE_ROLE = "Couldn't create role";
export var ROLE_DUPLICATE_MESSAGE = 'This role name has already been used once. You may edit the role or create one with a different name.';
export var READ = languageFile[localStorage.getItem('language')]["25481"];
export var WRITE = 'WRITE';
export var ROLE_DETAILS = 'Role Details';
export var MANAGE_ROLES = 'Manage Roles';
export var DELETE_ROLES = 'Delete role';
export var NO_USER = languageFile[localStorage.getItem('language')]["25661"];
export var USERS_IN_PROFILE = languageFile[localStorage.getItem('language')]["25631"];
export var USERS_ASSIGNED_TO_ROLE = languageFile[localStorage.getItem('language')]["25651"];
export var COULDNOT_CHANGE_ROLE = "Couldn't change role!";
export var DEFAULT_ROLE_INFO = languageFile[localStorage.getItem('language')]["25501"];
export var DELETE_ROLE_INFO = languageFile[localStorage.getItem('language')]["25611"];
export var YOU_DONT_HAVE_PERMISSION = "You don't have permission to change an owner's role.";
export var SUCCESS = 'SUCCESS';
export var ROLES_CHANGED = 'Roles changed';
export var ROLES_EDITED = 'Role has been edited!';
export var SAVE_ROLE = languageFile[localStorage.getItem('language')]["25591"];
export var ROLE_SAVED = 'Filter saved!';
export var LEFT = 'left';
export var SELECT = 'Select';
export var CUSTOM = 'CUSTOM';
export var STANDARD = 'STANDARD';
export var READ_ONLY = 'READ_ONLY';
export var ROLE_HAS_BEEN_USED = 'This role name has already been used!';
export var PLEASE_ENTER_FILTER_NAME = 'please enter a filter name';
export var NO_SAVED_FILTERS_FOUND = 'No saved filters found';
export var CREATE_FILTER = 'Create filter';
export var ASSIGN_USER = languageFile[localStorage.getItem('language')]["25621"];
export var GMT = 'GMT';
export var SELECT_WHICH_RESPONSE = languageFile[localStorage.getItem('language')]["22151"];
export var ASSIGN_RESPONSE = languageFile[localStorage.getItem('language')]["22141"];
export var CREATE_CAMPAIGN = languageFile[localStorage.getItem('language')]["21861"];
export var CAMPAIGN_NAME = languageFile[localStorage.getItem('language')]["21881"];
export var ALWAYS_ACTIVE = languageFile[localStorage.getItem('language')]["10124"];
export var RATING_SHORTCOMMENT = languageFile[localStorage.getItem('language')]["2057"];
export var CAMPAIGN_DESCRIPTION = languageFile[localStorage.getItem('language')]["21941"];
export var CAMPAIGN_DATE_RANGE = languageFile[localStorage.getItem('language')]["21921"];
export var CAMPAIGN_RESPONDER = languageFile[localStorage.getItem('language')]["21891"];
export var NOTE_GOALS = languageFile[localStorage.getItem('language')]["21931"];
export var CAMPAIGN_NAME_INSTRUCTION = languageFile[localStorage.getItem('language')]["21871"];
export var SET_TRIGGERS = languageFile[localStorage.getItem('language')]["21951"];
export var CHOOSE_TYPE_OF_REVIEW = languageFile[localStorage.getItem('language')]["21961"];
export var RATING = languageFile[localStorage.getItem('language')]["13520"];
export var REVIEWS = languageFile[localStorage.getItem('language')]["13574"];
export var WITH_COMMENT = languageFile[localStorage.getItem('language')]["21971"];
export var WITHOUT_COMMENT = languageFile[localStorage.getItem('language')]["21981"];
export var ALL = languageFile[localStorage.getItem('language')]["10204"];
export var ENTITY = languageFile[localStorage.getItem('language')]["22031"];
export var ORGANIZATION = languageFile[localStorage.getItem('language')]["22041"];
export var COUNTRY = languageFile[localStorage.getItem('language')]["10565"];
export var AREA = languageFile[localStorage.getItem('language')]["10225"];
export var LOCALITY = languageFile[localStorage.getItem('language')]["12362"];
export var SET_AUDIENCE = languageFile[localStorage.getItem('language')]["22011"];
export var SET_LOCATION_ENTITY_TAG = languageFile[localStorage.getItem('language')]["22021"];
export var SET_SCHEDULE = languageFile[localStorage.getItem('language')]["22051"];
export var SET_SCHEDULE_INFO = languageFile[localStorage.getItem('language')]["22061"];
export var SET_SCHEDULE_WARNING = languageFile[localStorage.getItem('language')]["22071"];
export var SET_RESPONSE_RATE = languageFile[localStorage.getItem('language')]["22081"];
export var SET_RESPONSE_COUNT = languageFile[localStorage.getItem('language')]["22091"];
export var PERCENTAGE = languageFile[localStorage.getItem('language')]["20241"];
export var HOUR = languageFile[localStorage.getItem('language')]["11535"];
export var MINUTES = languageFile[localStorage.getItem('language')]["27591"];
export var DELAY_BEFORE_SENDING_AR = languageFile[localStorage.getItem('language')]["22101"];
export var SELECT_TIMEZONE = languageFile[localStorage.getItem('language')]["22131"];
export var SCHEDULE_PERIODICALLY = languageFile[localStorage.getItem('language')]["22111"];
export var CONFIRM = languageFile[localStorage.getItem('language')]["22161"];
export var REVIEW_EACH_OF_THE_DETAILS_BELOW = languageFile[localStorage.getItem('language')]["22171"];
export var DATE_RANGE = languageFile[localStorage.getItem('language')]["10729"];
export var DESCRIPTION = languageFile[localStorage.getItem('language')]["10759"];
export var STAR_RATING = languageFile[localStorage.getItem('language')]["25791"];
export var RESPONSE_RATE = languageFile[localStorage.getItem('language')]["25771"];
export var RESPONSE_COUNT = languageFile[localStorage.getItem('language')]["25781"];
export var DELAY = 'Delay';
export var TIMEZONE = languageFile[localStorage.getItem('language')]["25831"];
export var ENTITY_TAG_NAME = 'Group name';
export var INTELLIGENT_AUTO_REPSONSE = languageFile[localStorage.getItem('language')]["21801"];
export var TURN_ON_AUTO_RESPONSE = languageFile[localStorage.getItem('language')]["21811"];
export var PLEASE_SELECT_TEMPLATE = 'Please select template for all selected star rating';
export var SUCCESSFULLY_UPDATED_CAMPAIGN = languageFile[localStorage.getItem('language')]["25761"];
export var SUCCESSFULLY_DELETED_CAMPAIGN = 'Succesfully deleted the campaign';
export var COMBINATION_ALREADY_EXIST = 'This response trigger combination already exists. Each review can have only one instruction set (location, group. rating, comment, etc.) to initiate a reply. Explore your current Campaign settings to identify the overlapping instructions.';
export var DELTE_CAMPAIGN_CONFIRMATION = languageFile[localStorage.getItem('language')]["29301"];
export var YES = languageFile[localStorage.getItem('language')]["22971"];
export var NO = languageFile[localStorage.getItem('language')]["22821"];
export var ON = languageFile[localStorage.getItem('language')]["25721"];
export var OFF = languageFile[localStorage.getItem('language')]["25731"];
export var COMMENTS = languageFile[localStorage.getItem('language')]["22351"];
export var DATE = languageFile[localStorage.getItem('language')]["10726"];
export var LOCATION_FILTER = 'Location Filter';
export var ENTITY_TAG = 'Group';
export var CAMPAIGN_BUILDER_INSTRUCTIONS_ONE = languageFile[localStorage.getItem('language')]["21831"];
export var CAMPAIGN_BUILDER_INSTRUCTIONS_TWO = languageFile[localStorage.getItem('language')]["21841"];
export var CAMPAIGN_BUILDER_INSTRUCTIONS_THREE = languageFile[localStorage.getItem('language')]["21851"];
export var CAMPAIGN_BUILDER_INSTRUCTIONS_HEADER = languageFile[localStorage.getItem('language')]["21821"];
export var WARNING_ICON = 'warning';
export var SELECT_DAY_SET_TIME = languageFile[localStorage.getItem('language')]["22121"];
export var INTEGRATIONS = languageFile[localStorage.getItem('language')]["26981"];
export var FACEBOOK = ' > Facebook';
export var FACEBOOK_LOCATIONS = languageFile[localStorage.getItem('language')]["28971"];
export var ADD_PAGE = languageFile[localStorage.getItem('language')]["28981"];
export var VIEW_FB_PAGE = languageFile[localStorage.getItem('language')]["29011"];
export var HIDE_THIS_ACCOUNT = 'Hide this account';
export var SHOW_THIS_ACCOUNT = 'Show this account';
export var HIDE_ACCOUNT_CONFIRM_CONTENT = 'Would you like to Hide this account from this profile? ';
export var SHOW_ACCOUNT_CONFIRM_CONTENT = 'Would you like to Unhide this account ? ';
export var DEACTIVATE_ACCOUNT_CONFIRM_CONTENT = "Would you like to remove this account's data from this profile? Removing data will take a few minutes depending on the amount of data in the account.";
export var PLEASE_DISABLE_YOUR_POPUP = 'Please disable your popup blocker and try again!';
export var FETCHING_DATA_FROM_ACCOUNT = 'Fetching data from account';
export var DEACTIVATED_ACCOUNT = 'Deactivated account';
export var LOCATIONS = 'Locations';
export var VIEW = languageFile[localStorage.getItem('language')]["24641"];
export var INTEGRATION_WINDOW_OPEN_PARAM = 'width=800,height=800,left=400,top=200,scrollbars=1,status=0';
export var SIGN_IN = 'SignIn';
export var UNDEFINED = 'undefined';
export var EMPTY_STATE_INFORMATION = 'You can add a Google Business Profile account to your current profile to import listings from it.';
export var WOULD_YOU_LIKE_TO_SYNC_LOCATION_DATA = '"Syncing" will pull into the platform any new locations in the underlying account and update all existing locations. Please note that it may take as long as two hours for all changes to take effect.';
export var RESYNC_INFORMATION = 'Subscribing to Google pub-sub service allow us to send real time notification reports via email. Only one pub-sub service can be activated for a Google Business Profile account at a time. Subscribing to this service will override any existing subscriptions, if you already have one.';
export var WHATS_THIS = 'Whats this?';
export var RESUBCRIBE_TO_GOOGLE = 'Re-subscribe to Google Pub-Sub  ';
export var TOTAL_LOCATION = languageFile[localStorage.getItem('language')]["24601"];
export var ACTIVE = languageFile[localStorage.getItem('language')]["20531"];
export var INACTIVE = languageFile[localStorage.getItem('language')]["24501"];
export var OK = 'OK';
export var DOWNLOAD = languageFile[localStorage.getItem('language')]["25531"];
export var ACTION = 'Action';
export var ACTIVE_LOCATIONS = 'Visible';
export var HIDDEN_LOCATIONS = 'Hidden';
export var SUPPRESSED_LOCATIONS = 'Suppressed';
export var PLATFORM_ONLY = 'Platform Only';
export var HIDDEN_KEY = 'hidden';
export var ACTIVE_KEY = 'active';
export var SUPPRESS_KEY = 'suppress';
export var PLATFORM = 'Platform';
export var LOCATION_LIST = 'Locations - ';
export var ACTIVATE = 'Activate Locations ';
export var HIDE_LOCATION = 'Hide Locations ';
export var HIDE = languageFile[localStorage.getItem('language')]["30351"];
export var ACTIVATE_LABEL = 'Activate';
export var REMOVED = 'removed';
export var ACTIVATED_KEY = 'activated';
export var SYNCING = 'Syncing...';
export var MANAGE_LOCATIONS = 'Manage locations';
export var UNABLE_TO_DOWNLOAD = 'Unable to download';
export var QUEUE = 'QUEUE';
export var ADMIN = 'ADMIN';
export var OWNER = 'OWNER';
export var AWESOME = 'AWESOME !';
export var DESC = 'DESC';
export var ASC = 'ASC';
export var DESCEND = 'descend';
export var HIDE_KEY = 'hide';
export var ACTIVATE_KEY = 'activate';
export var ACCOUNT_ACTIVATED = 'Account Activated';
export var YOUR_REQUEST_ADDED_TO_QUEUE = 'Your request added to  queue. Changes will take a few minutes to reflect on your account depending on the amount of data.';
export var GMB_ACCOUNT_AUTHORIZE_STARTED = 'GMB Account Authorization Started';
export var GMB_ACCOUNT_AUTHORIZE_COMPLETED = 'GMB Account Authorization Completed';
export var FETCHING_LOCATIONS = 'FETCHING_LOCATIONS';
export var USER_DOESNOT_HAVE_PERMISSION = 'User doesn\'t have permission to hide this location';
export var SOMETHING_WENT_WRONG = 'Something went wrong';
export var UNVERIFIED_LOCATION = 'Unverified location';
export var DISCONNECTED_LOCATION = 'Disconnected location';
export var VERIFIED_LOCATION = 'Verified location';
export var WE_ARE_BEGINNING_TO_FETCH = 'We are beginning to fetch your data now.You can now navigate to the ';
export var ARE_YOU_SURE = 'Are you sure ?';
export var PLEASE_SELECT_LOCATION = 'Please select a location ! ! !';
export var WOULD_YOU_LIKE_RETRIVE = 'Would you like to retrieve data from this account ?';
export var IN_PROGRESS = 'In Progress ...';
export var SYNC_YOUR_DATA = 'Syncing your data. This will take some time depending on the number of locations you have in this account.';
export var SYNC_FACEBOOK_DATA = '"Syncing" will pull into the platform any new locations in the underlying page and update existing page data. Please note that it may take as long as two hours for all changes to take effect.';
export var SYNC_YOUR_FACEBOOK_DATA = 'Syncing your data. This will take some time depending on the number of locations you have in this page.';
export var BELOW_ARE_ORGANIZATION_FOUND = 'Below are the organizations we found setup within Google Business Profile, Choose the one (or more) that you would to like to integrate into the profile';
export var EXCELLENT_YOUR_ALMOST = 'Excellent! You are almost there.';
export var GREAT_YOUR_PROFILE_CREATED = 'Great! Your profile is created.';
export var NOW_LETS_CONNECT = 'Now lets connect your Google Business Profile account to this profile.';
export var LANGUAGE_LABEL = 'language';
export var INPUT_SEARCH_SIZE = 'small';
export var BUTTON_SHAPE = 'circle';
export var BUTTON_SIZE = 'large';
export var DOWNLOAD_ICON_TYPE = 'download';
export var DELETE_ICON_TYPE = 'delete';
export var DOWNLOAD_TOOLTIP = languageFile[localStorage.getItem('language')]["25531"];
export var DELETE_TOOLTIP = languageFile[localStorage.getItem('language')]["10750"];
export var ALL_DOWNLOAD = languageFile[localStorage.getItem('language')]["23241"];
export var REVIEW_SOURCE = languageFile[localStorage.getItem('language')]["13565"];
export var DOWNLOAD_ICON_FA_FA = 'fa fa-download'; // localstorage read & write items

export var PROFILE_ID = 'profileId';
export var ACCEPT_AUTH = 'AcceptAuth';
export var PROFILE_NAME = 'profileName';
export var USER_ID = 'userId'; // routes links are defined here

export var LINK_TO_MANAGE_ROLES = '/settings/manageRoles';
export var LINK_TO_ADD_ACCOUNT = '/settings/addAccount';
export var LINK_TO_INTEGRATIONS = '/settings/integrations';
export var LINK_TO_DASHBOARD = '/dashboard';
export var LINK_TO_INVITE_USER = '/settings/inviteUser'; // URLS

export var FACEBOOK_URL = 'https://facebook.com/'; //Image paths

export var OPEN_LOCK = '/images/open-lock.png';
export var NOT_VERIFIED = '/images/Not_Verified.png';
export var DISCONNECTED_IMG = '/images/disconnect-red.png';
export var PLATFORM_ONLY_IMG = '/images/platformOnly.png';
export var DETACHED_ICON = '/images/detached-orange.png';
export var LINKED_ICON = '/images/linked-green.png'; //language related keys are defined here

export var LANGUAGE_KEY = 'language';
export var FEATURE_ACCESS_KEY = '11120';
export var ADD_NEW_ROLE = '10165';
export var CREATE_ROLE_BUTTON = '10592';
export var CANCEL_BUTTON = '10523';
export var OK_GOT_IT_BUTTON = '12929';
export var MANAGE_ROLE = '12538';
export var ADD_ROLE = '10180';
export var ROLE = '13598';
export var NO_OF_USERS = '12753';
export var CREATED_BY = '10595';
export var ACTIONS = '10120';
export var SPECIFIC_ACCESS = '13855';
export var ALL_USER_TITLE = '10210';
export var LIMIT_ACCESS = '14926';
export var ROLE_NAME = '13604';
export var NEW_ROLE_NAME = '12723';
export var SELECT_EXISTING_FILTER = '13759';
export var SELECT_FILTER = '13783';
export var CREATE_NEW_FITER = '10577';
export var DASHBOARD = '10723';
export var LPO = '12353';
export var REVIEW_MANAGEMENT = '13586';
export var LISTING_MANAGEMENT = '12347';
export var SETTINGS = '13825';
export var CLICK_ON_USER_TO_ASSIGN = '10544';
export var SAVE_BUTTON = '13723';
export var DELETE_BUTTON = '10750';
export var NO_CANCEL_BUTTON = '12750';
export var YES_CANCEL_BUTTON = '14923';
export var EDIT = '10920';
export var SELECT_ENTITY_TAG = '13780';
export var SELECT_ORGANIZATION = '13792';
export var SELECT_COUNTRY = '13768';
export var SELECT_STATE = '13804';
export var SELECT_CITY = '13765';
export var APPLY_BUTTON = '10213';
export var AUTHORIZE_ACCOUNT = '10234';
export var AUTOMATE = 'Automate';
export var ADD_ACCOUNT = '10144';
export var ACTIVE_ORGANIZATION = '10126';
export var LAST_UPDATED = '12326';
export var ENTER_SEARCH_TEXT = '10950';
export var SEARCH_TEXT_PLACEHOLDER = '27501';
export var DEACTIVATE = '10735';
export var ACTIVATED = '10123';
export var SYNC_THIS_ACCOUNT = '13885';
export var STATIC_HREF = 'JavaScript:void(0);';